<template>
  <ControlBox :title="title">
    <slot />
    <el-button class="btn-add" type="primary" @click="handleAdd">添加图片</el-button>
    <c-source-table :table="{ data: value }" :columns="columns" />
  </ControlBox>
</template>

<script>
import { Vue, Component, Prop, Model } from 'vue-property-decorator';
import ControlBox from './control-box';

@Component({
  components: {
    ControlBox
  }
})
export default class ImageControlBox extends Vue {
  @Model('change', { type: Array, default: () => [] }) value;
  @Prop({ type: Array, default: () => [] }) links;
  @Prop(String) title;

  get columns() {
    return [
      {
        prop: 'src',
        label: '图片',
        renderCell: (h, { row, $index }) => {
          return <c-upload-form-item value={row.src} onChange={(val) => this.handleUpdateImage(val, $index)} />
        }
      },
      {
        prop: 'link',
        label: '跳转链接',
        renderCell: (h, { row, $index }) => {
          const selectProps = {
            value: row.link,
            options: this.links
          }
          return <c-select props={selectProps} filterable={true} clearable={true} onChange={(val) => this.handleUpdateLink(val, $index)} />
        }
      },
      {
        prop: 'medium_id',
        label: '图片编号'
      },
      {
        prop: 'click_count',
        label: '点击次数'
      },
      {
        prop: 'action',
        label: '操作',
        delete: {
          handler: ({ $index }) => this.handleDelete($index)
        },
        extraAction: (h, { $index }) => {
          return [
            $index - 1 >= 0 && {
              title: '上移',
              handler: () => this.handleUp($index)
            },
            $index + 1 < this.value.length && {
              title: '下移',
              handler: () => this.handleDown($index)
            },
            {
              title: '删除',
              handler: () => this.handleDelete($index)
            }
          ]
        }
      }
    ]
  }

  syncChange() {
    this.$emit('change', this.value);
  }

  handleAdd() {
    const newImage = { src: '', link: '' }
    this.value.push(newImage);
    this.syncChange();
  }

  handleDelete($index) {
    this.value.splice($index, 1);
    this.syncChange();
  }

  handleUpdateImage(imageUrl, $index) {
    this.$set(this.value[$index], 'src', imageUrl);
    this.$set(this.value[$index], 'click_count', 0);
    this.syncChange();
  }

  handleUpdateLink(link, $index) {
    this.$set(this.value[$index], 'link', link);
    this.syncChange();
  }

  handleUp($index) {
    const current = this.value.splice($index, 1)[0];
    this.value.splice($index - 1, 0, current);
    this.syncChange();
  }

  handleDown($index) {
    const current = this.value.splice($index, 1)[0];
    this.value.splice($index + 1, 0, current);
    this.syncChange();
  }

}
</script>

<style lang="scss" scoped>
  .btn-add {
    margin-bottom: 20px;
  }

  /deep/ .upload-form-item {
    .resource-content {
      justify-content: center;

      .preview-image .image {
        width: 50px;
        height: 50px;
      }
    }
  }
</style>
